import { useCallback, useState, useMemo } from 'react';
import { Tooltip } from 'reactstrap';

const CopyFieldWrapper = ({ value, children }: { value: string; children: React.ReactNode }) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }, [value]);
  const tooltipId = useMemo(() => `copy-button-${Math.floor(Math.random() * 1000000)}`, []);
  return (
    <div className="d-flex flex-row gap-2">
      {children}
      <i id={tooltipId} className="ri-file-copy-2-line cursor-pointer" onClick={handleCopy}></i>
      <Tooltip target={tooltipId} isOpen={isCopied} placement="top">
        Copied!
      </Tooltip>
    </div>
  );
};

export default CopyFieldWrapper;
